























import { Vue, Component } from "vue-property-decorator";
import OrderFormEdit from "@/components/orders/OrderFormEdit.vue";
import { LearningRequest as ILearningRequest } from "@/api/models/learning-request";
import api from "@/getinfo-api";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: { CBreadCrumbs, OrderFormEdit }
})
export default class OrderEdit extends Vue {
  order!: ILearningRequest;
  data() {
    return {
      order: undefined
    };
  }

  getLearningRequest() {
    api.LearningRequestApi.get(this.$route.params.orderId).then(
      (res: { data: ILearningRequest }) => {
        this.order = res.data;
        document.title += ` ${this.order.number}`;
      }
    );
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "orders" },
        label: `${this.$tc(this.$translate.LearningRequests)}`
      },
      {
        to: { name: "orderItem", params: { orderId: this.order.id } },
        label: this.order.number
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  mounted() {
    this.getLearningRequest();
  }

  getLearningUsersList() {
    api.LearningRequestApi.get(this.$route.params.orderId).then(
      (res: { data: ILearningRequest }) => {
        this.order.users = res.data.users;
      }
    );
  }
}
